import React from "react";
import { ArrowCircleLeftOutlined } from "@mui/icons-material";
import { Button, CircularProgress } from "@mui/material"; // Import CircularProgress

const MainButton = ({ onClick, disabled, loading, children, btnLabel, icon }) => {
  return (
          <Button
            onClick={onClick}
            sx={{
              background: "linear-gradient(to right, #3861C5 0%, #4AA3EE 100%)",
              color: (disabled || loading) ? "#113391" : "#ffffff", // Darken color when disabled or loading
              // On small screens (xs), ensure CTA is the second element
              order: { xs: 2, sm: 0 },
              py:1,
              position: 'relative', // for spinner positioning
            }}
            variant="contained"
            fullWidth
            disabled={disabled || loading} // Disable if explicitly disabled or loading
          >
            {loading ? ( // Display spinner when loading
                <CircularProgress size={24} sx={{ color: 'white' }} />
            ) : (
                <>
                    {icon} {btnLabel}
                </>
            )}
            
          </Button>
  );
};

const SecondaryButton = ({onClick, disabled, children, btnLabel, fullWidth, icon, variant, loading}) => {
  return (
    <Button
            onClick={onClick}
            color="primary"
            variant={variant || "text"}
            sx={{
              background: "#4ba5ee41",
              // On small screens (xs), push the back button to the top left
              order: { xs: 1, sm: 0 },
              py:1,
              px:(fullWidth == true) ? 0 : 2
            }}
            fullWidth = {fullWidth}
            disabled={disabled || loading}
          >
            {loading ? (
                <CircularProgress size={24} sx={{ color: 'primary' }} />
            ) : (
                <>
                    {icon || <ArrowCircleLeftOutlined sx={{ mr: 0.5 }} />} {btnLabel}
                </>
            )}
          </Button>
  )
}

const SelectionButton = ({onClick, disabled, children, color, btnLabel, fullWidth, icon, variant,}) => {
  return (
    <Button
            onClick={onClick}
            color={color || "primary"}
            variant={variant || "outlined"}
            sx={{
              background: "#4ba5ee41",
              // On small screens (xs), push the back button to the top left
              order: { xs: 1, sm: 0 },
              py:3,
              px:(fullWidth == true) ? 0 : 2,
              fontWeight:'bold'
            }}
            fullWidth = {fullWidth}
          >
            {icon } {btnLabel}
          </Button>
  )
}

export {MainButton, SecondaryButton, SelectionButton};
